var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3589 12.8333L7.97556 10.45C7.68528 10.1597 7.6205 9.82758 7.78123 9.45358C7.94134 9.07897 8.22764 8.89166 8.64014 8.89166H13.361C13.7735 8.89166 14.0598 9.07897 14.2199 9.45358C14.3806 9.82758 14.3158 10.1597 14.0256 10.45L11.6422 12.8333C11.5506 12.925 11.4513 12.9937 11.3443 13.0396C11.2374 13.0854 11.1228 13.1083 11.0006 13.1083C10.8783 13.1083 10.7638 13.0854 10.6568 13.0396C10.5499 12.9937 10.4506 12.925 10.3589 12.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDown);
export default __webpack_public_path__ + "static/media/arrowDropDown.d4b600c1e5235dca9c6c6440abb441bc.svg";
export { ForwardRef as ReactComponent };